import {
  DatePicker,
  Form,
  Input,
  InputNumber,
  Select,
  ColorPicker,
} from "antd";
import React, { useRef, useState } from "react";
import { withTranslation } from "react-i18next";
import {
  Row,
  Button,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import { renderFormComponent } from "../../utility";
import { preventSpecialCharacterRegex } from "../../../config/validation";

const CustomPageModal = ({
  modal,
  isEdit,
  onSubmit,
  pageName,
  onCloseModal,
  dataModal,
  t,
  createTitle,
  editTitle,
  isSubmitting,
  formRef,
  lstDisabled
}) => {
  const [form] = Form.useForm();

  return (
    <Modal isOpen={modal} toggle={onCloseModal} style={{ maxWidth: 1000 }}>
      <Form layout="vertical" onFinish={onSubmit} validateTrigger="submit" ref={formRef}>
        <ModalHeader>
          {!isEdit
            ? createTitle || `${t("AddNew")} ${t(pageName)}`
            : editTitle || ` ${"Cập nhật thông tin người dùng"}`} 
            {/* ${t("Update")} */}
        </ModalHeader>
        <ModalBody>
          <Row>
            {dataModal.map((item, idx) => {
              return (
                item.showModal && (
                  <Col lg={item.widthModal} key={item.accessor || `accessor-${idx}`} id={`${item.accessor}Item`}>
                    <Form.Item
                      label={item.Header}
                      name={item.accessor}
                      rules={[
                        ...(item && item.rules && Array.isArray(item.rules)
                          ? item.rules
                          : item.rules || []),
                        ...(item && item.preventSpecialCharacters
                          ? [
                              {
                                pattern: preventSpecialCharacterRegex,
                                message: t(
                                  "Please don't use special characters"
                                ),
                              },
                            ]
                          : []),
                      ]}
                      initialValue={item.initialValue}
                      valuePropName={item.valuePropName}
                      getValueFromEvent={item.getValueFromEvent}
                    >
                      {renderFormComponent(item, lstDisabled, form, item.accessor)}
                    </Form.Item>
                  </Col>
                )
              );
            })}
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="danger" className="ml-2" onClick={onCloseModal}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="18"
              width="18"
              viewBox="0 0 512 512"
              className="mr-1"
              style={{ marginBottom: 3 }}
            >
              <path
                fill="white"
                d="M377.9 105.9L500.7 228.7c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3L377.9 406.1c-6.4 6.4-15 9.9-24 9.9c-18.7 0-33.9-15.2-33.9-33.9l0-62.1-128 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l128 0 0-62.1c0-18.7 15.2-33.9 33.9-33.9c9 0 17.6 3.6 24 9.9zM160 96L96 96c-17.7 0-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-53 0-96-43-96-96L0 128C0 75 43 32 96 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32z"
              />
            </svg>
            {t("Đóng")}
          </Button>
          <Button
            color="success"
            className="mr-2"
            type="submit"
            disabled={isSubmitting}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="16"
              width="16"
              viewBox="0 0 512 512"
              className="mr-1"
              style={{ marginBottom: 3 }}
            >
              <path
                fill="white"
                d="M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z"
              />
            </svg>
            {isSubmitting ? t("Đang xử lý") : t("Lưu")}
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default withTranslation(["configure"])(CustomPageModal);
